<template>
  <div class="not-found">
    <div class="container">
      <div class="not-found-content">
        <h1>404</h1>
        <h2>Page Not Found</h2>
        <p>The page you're looking for is currently unavailable or doesn't exist.</p>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
// No imports needed
</script>

<style scoped>
.not-found {
  min-height: 80vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem 0;
}

.container {
  max-width: 600px;
  margin: 0 auto;
  padding: 0 2rem;
}

.not-found-content {
  text-align: center;
}

.not-found-content h1 {
  font-size: 8rem;
  font-weight: bold;
  color: rgba(255, 255, 255, 0.1);
  margin: 0;
  line-height: 1;
}

.not-found-content h2 {
  font-size: 2.5rem;
  color: white;
  margin: 1rem 0;
}

.not-found-content p {
  font-size: 1.2rem;
  color: rgba(255, 255, 255, 0.8);
  margin-bottom: 0;
  font-family: "Playfair Display", serif;
  font-style: italic;
}

@media (max-width: 768px) {
  .not-found-content h1 {
    font-size: 6rem;
  }
  
  .not-found-content h2 {
    font-size: 2rem;
  }
}
</style>
